import { render, staticRenderFns } from "./landDetail.vue?vue&type=template&id=a7650170&scoped=true"
import script from "./landDetail.vue?vue&type=script&lang=js"
export * from "./landDetail.vue?vue&type=script&lang=js"
import style0 from "./landDetail.vue?vue&type=style&index=0&id=a7650170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7650170",
  null
  
)

export default component.exports